import { createContext } from 'react';
const UsageTrackerContext = /*#__PURE__*/createContext(__properties => {});
export default UsageTrackerContext;